import {
    LanguageModelTask,
    LanguageModelTaskResult,
    WorkflowToolRequest,
    WorkflowToolResult,
} from '#types/System.Agents.types';
import type { PdfIntakeTaskRequest, PdfIntakeTaskResult, PricebookTaskRequest, PricebookTaskResponse } from '#types';
import type { ResponseHandler } from '../types';

export const taskHandler: ResponseHandler<LanguageModelTask | WorkflowToolRequest | PdfIntakeTaskRequest | PricebookTaskRequest> = {
    isApplicable: (r): r is LanguageModelTask | WorkflowToolRequest | PdfIntakeTaskRequest | PricebookTaskRequest =>
        'taskType' in r && !!r.taskType,
    handle: async (response, _request, { onComplete }) => {
        const result = await response.json() as LanguageModelTaskResult | WorkflowToolResult | PdfIntakeTaskResult | PricebookTaskResponse;
        onComplete?.(result);
        return result;
    },
};
